import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getTaskManagementEventList, ITaskManagementEventModel } from "api";
import { CalendarFilterOption } from "pages/user-portal/employee/homepage";
import { store } from "store";

const initialState = {
  eventList: [] as ITaskManagementEventModel[],
  loading: false,
};

export const fetchEventList = createAsyncThunk(
  "events/fetchEventList",
  async () => {
    const args: Record<string, any> = {};

    const queryParams = store.getState().FiltersReducer;

    if (queryParams?.filters?.length) {
      queryParams.filters.forEach((item: Record<string, any>) => {
        for (const [key, value] of Object.entries(item)) {
          if (
            Object.values(CalendarFilterOption).includes(
              key as CalendarFilterOption
            )
          ) {
            args[key] = value;
          }
        }
      });
    }

    const response = await getTaskManagementEventList(args);

    return response;
  }
);

const eventSlice = createSlice({
  name: "events",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEventList.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        eventList: action.payload,
        loading: false,
      };
    });
    builder.addCase(fetchEventList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export default eventSlice.reducer;
